"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const fsahsaeligible = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-fsahsaeligible` : '') + (description ? ` desc-fsahsaeligible` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-fsahsaeligible"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-fsahsaeligible"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0a22.45 22.45 0 0 1 9.182 1.874l.012.005A2.236 2.236 0 0 1 22.5 3.925v7.612a12.656 12.656 0 0 1-8.113 11.813l-1.04.4a3.75 3.75 0 0 1-2.693 0l-1.041-.4A12.658 12.658 0 0 1 1.5 11.537V3.925A2.236 2.236 0 0 1 2.806 1.88l.012-.005A22.45 22.45 0 0 1 12 0ZM3.425 3.245A.736.736 0 0 0 3 3.918v7.619a11.157 11.157 0 0 0 7.151 10.413l1.041.4c.52.2 1.096.2 1.616 0l1.04-.4A11.157 11.157 0 0 0 21 11.537v-7.62a.736.736 0 0 0-.425-.672A20.95 20.95 0 0 0 12.007 1.5h-.014a20.95 20.95 0 0 0-8.568 1.745ZM9.439 4.94A1.5 1.5 0 0 1 10.5 4.5h3A1.5 1.5 0 0 1 15 6v1.5h1.5A1.5 1.5 0 0 1 18 9v3a1.5 1.5 0 0 1-1.5 1.5H15V15a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 15v-1.5H7.5A1.5 1.5 0 0 1 6 12V9a1.5 1.5 0 0 1 1.5-1.5H9V6c0-.398.158-.78.44-1.06ZM10.5 6v2.25a.75.75 0 0 1-.75.75H7.5v3h2.25a.75.75 0 0 1 .75.75V15h3v-2.25a.75.75 0 0 1 .75-.75h2.25V9h-2.25a.75.75 0 0 1-.75-.75V6h-3Z",
    fill: "#000"
  }));
};
var _default = exports.default = fsahsaeligible;